<template>
    <div style="padding-top: 200px;text-align: center" >
        <div class="btn-group" role="group" aria-label="...">
            <button type="button" class="btn btn-default">Left</button>
            <button type="button" class="btn btn-default">Middle</button>
            <button type="button" class="btn btn-default">Right</button>
        </div>
    </div>
</template>
<script>
    import {appjs} from '@/utiljs/apputil'
    export default {
        data () {
            return {
                loginText:'登录'
            };
        },
        created() {
        },
        mounted() {
        },
        methods: {

        }
    };
</script>
<style>
</style>
